import { Environment, getEnvironmentConfig as getSharedConfig } from '@mapp-byte-connect/config';

const environment: Environment =
  (import.meta.env.VITE_BUILD_ENV as Environment) || ('local' as Environment);

export const currentEnvironment = environment;
export const environmentConfig = getSharedConfig(environment);
